import React from 'react';
import { Checkbox } from "../../../inputs/Checkbox";
import { getPrivacyConsentLabel } from "../../../../utils/get-privacy-consent-label";
export var getPrivacyCheckboxMarkup = function getPrivacyCheckboxMarkup(privacyConsentInputError, isPrivacyConsentInputChecked, privacyConsentLabelText, privacyConsentLabelLinkUrl, privacyConsentLabelLinkText, onClickPrivacyConsentInput) {
  return React.createElement(Checkbox, {
    error: privacyConsentInputError,
    isChecked: isPrivacyConsentInputChecked,
    label: getPrivacyConsentLabel(privacyConsentLabelText, privacyConsentLabelLinkUrl, privacyConsentLabelLinkText),
    onClick: onClickPrivacyConsentInput
  });
};